import { store } from '@/common/root';
import jsonParseSafe from '@/common/utils/jsonParseSafe';
import applyColors from '@/common/utils/applyColors';
import usePermissionsStore from '@/common/store/pinia/permissions';
import useAuthStore from '@/common/store/pinia/auth';

async function init(pinia) {
  applyColors();
  const permissionsStore = usePermissionsStore(pinia);
  const authStore = useAuthStore(pinia);
  /* Fetch and Set the current user in case there's one */
  if (typeof window === 'undefined') {
    return;
  }

  const userCredentials = window.localStorage.getItem('user');

  // TODO check if user successfully authenticated
  if (userCredentials) {
    authStore.setCurrentUser(jsonParseSafe(userCredentials) || {});
    await Promise.allSettled([
      store.dispatch('socket/CONNECT'),
      store.dispatch('projects/FETCH_ITEMS'),
      permissionsStore.fetchAuthMeta()
    ]);
  }
}

export default init;
